import { Container, Grid } from '@mui/material'
import OrderwireLogo from './OrderwireLogo'
import { Box } from '@mui/system'
import FormStepper from './FormStepper'
import StepLabels from './StepLabels'

function FormLayout({ children }: { children: React.ReactNode }) {
    return (
        <Container
            sx={{
                mt: { md: 2 },
                height: {
                    sm: '100vh',
                    xs: '100vh',
                    md: '95vh',
                },
                overflow: 'hidden',
                maxWidth: 'md',
                justifyContent: 'center',
                display: 'flex',
                p: 0,
            }}
        >
            <Box
                sx={{
                    backgroundColor: '#ffffff33',
                    height: '100%',
                    borderRadius: {
                        xs: 0,
                        sm: 0,
                        md: 8,
                    },
                    px: {
                        xs: 2,
                        sm: 2,
                        md: 2,
                    },
                }}
            >
                <Grid container maxWidth={'md'} direction="column">
                    <Grid item container justifyContent={'center'} mt={1}>
                        <OrderwireLogo />
                    </Grid>
                    <Grid item>
                        <FormStepper />
                    </Grid>
                    <Grid
                        item
                        container
                        px={{
                            xs: 1,
                            sm: 1,
                            md: 4,
                        }}
                    >
                        <Grid item xs={12}>
                            <StepLabels />
                        </Grid>
                        <Grid
                            item
                            xs={12}
                            sx={{
                                mt: 2,
                                textAlign: 'center',
                            }}
                        >
                            {children}
                        </Grid>
                    </Grid>
                </Grid>
            </Box>
        </Container>
    )
}

export default FormLayout
